import { useTranslation } from "react-i18next";

import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Flex, Row, Space, Button } from "antd";
import EmployeeSalaryLiabilitiesTable from "components/table/EmployeeSalaryLiabilitiesTable";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

function EmployeeSalaryLiabilities({
  pagination = {},
  isLoading = false,
  accumulateList = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  onFilter = () => { },
  onCreate = () => { },
}) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="end">
        <Space direction="horizontal" size={24}>
          <Button type="default" onClick={onFilter}
            style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>
          <Button onClick={onCreate} type="primary"
            style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <CreateIcon />
              <span>{t('common.create')}</span>
            </Flex>
          </Button>
        </Space>
      </Row>
      <EmployeeSalaryLiabilitiesTable
        isLoading={isLoading}
        dataSource={accumulateList}
        pagination={pagination}
        onEdit={onEdit}
        onDelete={onDelete}
        onChange={onChange}
      />
    </Space>
  );
}

export default EmployeeSalaryLiabilities;
